var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { forwardRef, useState } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import { FilterItems } from './filter-item';
import { SearchAndFilterContext } from './context';
import Form from '../form';
import '../style/search-and-filter.less';
import useForm from '../useForm';
import { SearchItems } from './search-item';
import { Expand } from './expand';
import { Triggers } from './triggers';
import { defaultRender } from './utils';
var SearchAndFilterRender = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e;
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-search-and-filter");
    var _f = props.filterItemsProps, filterItemsProps = _f === void 0 ? {} : _f, _g = props.formProps, formProps = _g === void 0 ? {} : _g, _h = props.searchItemsProps, searchItemsProps = _h === void 0 ? {} : _h, _j = props.expandProps, expandProps = _j === void 0 ? {} : _j, _k = props.triggersProps, triggersProps = _k === void 0 ? {} : _k, _l = props.renderForm, renderForm = _l === void 0 ? defaultRender : _l, _m = props.renderFormItems, renderFormItems = _m === void 0 ? defaultRender : _m;
    var form = (React.createElement(Form, __assign({ className: cx("".concat(prefixCls, "-form"), formProps.className), optional: __assign({ show: false }, ((_a = (typeof formProps.optional === 'boolean' ? {} : formProps.optional)) !== null && _a !== void 0 ? _a : {})) }, formProps), renderFormItems(React.createElement(React.Fragment, null,
        ((_b = filterItemsProps.visible) !== null && _b !== void 0 ? _b : true) && React.createElement(FilterItems, __assign({}, filterItemsProps)),
        ((_c = searchItemsProps.visible) !== null && _c !== void 0 ? _c : true) && React.createElement(SearchItems, __assign({}, searchItemsProps)),
        ((_d = expandProps.visible) !== null && _d !== void 0 ? _d : true) && React.createElement(Expand, __assign({}, expandProps)),
        ((_e = triggersProps.visible) !== null && _e !== void 0 ? _e : true) && React.createElement(Triggers, __assign({}, triggersProps))))));
    return (React.createElement("div", { className: prefixCls, ref: ref }, renderForm(form)));
});
var SearchAndFilterWrapper = forwardRef(function (props, ref) {
    var _a, _b;
    var _c = __read(useForm(), 1), form = _c[0];
    form = (_a = props.formProps.form) !== null && _a !== void 0 ? _a : form;
    var _d = __read(useState(props.defaultMoreFilterVisible), 2), moreFilterVisible = _d[0], setMoreFilterVisible = _d[1];
    var config = {
        moreFilter: {
            visible: moreFilterVisible,
            setVisible: setMoreFilterVisible,
        },
        form: form,
    };
    return (React.createElement(SearchAndFilterContext.Provider, { value: config },
        React.createElement(SearchAndFilterRender, __assign({}, props, { ref: ref, formProps: __assign(__assign({}, ((_b = props.formProps) !== null && _b !== void 0 ? _b : {})), { form: form }) }))));
});
var SearchAndFilter = SearchAndFilterWrapper;
SearchAndFilter.Context = SearchAndFilterContext;
export { SearchAndFilter };
